import TrackedLink from '@/components/tracking/TrackedLink'
import LeanMark from '@/components/ui/LeanMark'
import { storyUrl } from '@/utils/date'
import { shortDate } from './format'

// A storyline's chapters, newest first (the identity mocks, 2026-11-01). On
// desktop each is a row: the date in a 70px column, the title and the lede's
// first sentence, then the row mark (LeanMark) in a 160px column (the aside narrows it), as on
// Today. On a phone each chapter is one tap row: date, title, row mark.
//
// A chapter is a story, so the counts are its articles by side and the
// label is the stored one its page and Today show.

export default function StorylineChapters({ chapters = [], slug }) {
  return chapters.map((c) => {
    const node = {
      lean: c.wings,
      coverage_label: c.coverage_label,
      coverage_color: c.coverage_color,
    }
    return (
      <div
        key={c.id}
        className="relative border-b border-border py-3.5 sm:grid sm:grid-cols-[70px_minmax(0,1fr)_160px] sm:items-start sm:gap-4 sm:py-4"
      >
        <span className="block font-sans text-[11px] text-muted-foreground sm:pt-1 sm:text-[13px]">
          {shortDate(c.day)}
        </span>
        <div className="min-w-0">
          {/* On a phone the title's link covers the whole row. */}
          <TrackedLink
            href={storyUrl(c) || '#'}
            event="story_click"
            params={{
              source_surface: 'storyline_chapters',
              story_slug: c.slug,
              storyline_slug: slug,
            }}
            className="mt-1 block font-serif text-lg font-normal leading-[1.25] text-foreground after:absolute after:inset-0 after:content-[''] sm:static sm:mt-0 sm:inline sm:text-xl sm:after:content-none sm:hover:underline"
          >
            {c.title}
          </TrackedLink>
          {c.summary && (
            <p className="mt-1 hidden font-serif text-[15px] leading-[1.45] text-secondary-foreground sm:block">
              {c.summary}
            </p>
          )}
        </div>
        <LeanMark node={node} className="mt-2.5 sm:mt-1" />
      </div>
    )
  })
}
